import ApiService from '../../api.service';
const moduleName = 'servorgs/uploads';

const uploadsService = {
    get: async (servOrgID, itemsPerPage, currentItem) => {
        try {
            let response = await ApiService.get(moduleName, {
                params: {
                    servOrgID,
                    itemsPerPage,
                    currentItem
                }
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    filter: async function(servOrgID, itemsPerPage, currentItem, filter_data) {
        try {
            let response = await ApiService.post(moduleName + '/filter', { servOrgID, itemsPerPage, currentItem, filter_data });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getFileDetail: async function(id) {
        try {
            let response = await ApiService.get(moduleName + `/${id}`);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getFileMeters: async function(id) {
        try {
            let response = await ApiService.get(moduleName + `/${id}/meters`);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getServorgUsers: async function() {
        try {
            let response = await ApiService.get('refs/servorgsUsers');
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getStatusList: async function() {
        try {
            let response = await ApiService.get('refs/status_rid');
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    uploadFile: async function(data) {
        try {
            let response = await ApiService.post(moduleName, data);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    previewFile: async function(id) {
        try {
            let response = await ApiService.post(moduleName + '/preview', { id });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getPreviewData: async function(fileID, itemsPerPage, currentItem, filter_data) {
        try {
            let response = await ApiService.post(moduleName + '/preview/filter', { id: fileID, itemsPerPage, currentItem, filter_data });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getGroupedData: async function(fileID, itemsPerPage, currentItem, filter_data) {
        try {
            let response = await ApiService.post(moduleName + '/preview/groupedData/filter', { id: fileID, itemsPerPage, currentItem, filter_data });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getFactData: async function(fileID, itemsPerPage, currentItem, filter_data) {
        try {
            let response = await ApiService.post(moduleName + '/preview/factData/filter', { id: fileID, itemsPerPage, currentItem, filter_data });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    confirmUpload: async function(id) {
        try {
            let response = await ApiService.post(moduleName + '/confirm', { id });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    cancelUpload: async function(id) {
        try {
            let response = await ApiService.post(moduleName + '/cancel', { id });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    }
};

export default uploadsService;
